const NAME = "FEEDBACK_PURPOSE";

export default NAME;
